"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const THREE = __importStar(require("three"));
const fiber_1 = require("@react-three/fiber");
const drei_1 = require("@react-three/drei");
const drei_2 = require("@react-three/drei");
const ConeVisualization = ({ planePosition, planeAngle, onIntersection }) => {
    const coneRef = (0, react_1.useRef)(null);
    const planeRef = (0, react_1.useRef)(null);
    const [intersectionPoints, setIntersectionPoints] = (0, react_1.useState)([]);
    (0, fiber_1.useFrame)(() => {
        if (planeRef.current && coneRef.current) {
            planeRef.current.rotation.x = planeAngle;
            planeRef.current.position.y = planePosition;
            // Calculate intersection
            const cone = coneRef.current;
            const plane = planeRef.current;
            if (cone && plane) {
                const intersections = new THREE.Raycaster()
                    .intersectObject(cone);
                setIntersectionPoints(intersections.map((i) => i.point));
            }
            // Determine curve type
            let curveType = '';
            let equation = '';
            if (Math.abs(planeAngle) < 0.1) {
                curveType = 'Circle';
                equation = 'x² + y² = r²';
            }
            else if (Math.abs(planeAngle) < Math.PI / 4) {
                curveType = 'Ellipse';
                equation = 'x²/a² + y²/b² = 1';
            }
            else if (Math.abs(planeAngle - Math.PI / 4) < 0.1) {
                curveType = 'Parabola';
                equation = 'y² = 4ax';
            }
            else {
                curveType = 'Hyperbola';
                equation = 'x²/a² - y²/b² = 1';
            }
            onIntersection(curveType, equation);
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("mesh", { ref: coneRef, rotation: [0, 0, 0], scale: [1.8, 1.8, 1.8] },
            react_1.default.createElement("coneGeometry", { args: [1.8, 3.6, 64] }),
            react_1.default.createElement("meshStandardMaterial", { color: "#6366f1", emissive: "#818cf8", emissiveIntensity: 0.5, wireframe: false, transparent: true, opacity: 0.9, side: THREE.DoubleSide })),
        react_1.default.createElement("mesh", { ref: planeRef, rotation: [planeAngle, 0, 0], position: [0, planePosition, 0] },
            react_1.default.createElement("planeGeometry", { args: [6, 6] }),
            react_1.default.createElement("meshStandardMaterial", { color: "#f97316", emissive: "#fb923c", emissiveIntensity: 0.3, transparent: true, opacity: 0.8, side: THREE.DoubleSide })),
        intersectionPoints.length > 0 && (react_1.default.createElement(drei_2.Line, { points: intersectionPoints, color: "#f59e0b", lineWidth: 3 }))));
};
const ConicSectionsVisualization = () => {
    const [planePosition, setPlanePosition] = (0, react_1.useState)(0);
    const [planeAngle, setPlaneAngle] = (0, react_1.useState)(0);
    const [curveType, setCurveType] = (0, react_1.useState)('');
    const [equation, setEquation] = (0, react_1.useState)('');
    return (react_1.default.createElement("div", { className: "conic-sections" },
        react_1.default.createElement("div", { className: "visualization-header" },
            react_1.default.createElement("h1", null, "Conic Sections"),
            react_1.default.createElement("p", null, "Explore how different plane intersections create circles, ellipses, parabolas and hyperbolas.")),
        react_1.default.createElement("div", { className: "controls" },
            react_1.default.createElement("div", { className: "control-group" },
                react_1.default.createElement("label", null,
                    "Plane Position: ",
                    planePosition.toFixed(2)),
                react_1.default.createElement("input", { type: "range", min: "-1", max: "1", step: "0.01", value: planePosition, onChange: (e) => setPlanePosition(parseFloat(e.target.value)) })),
            react_1.default.createElement("div", { className: "control-group" },
                react_1.default.createElement("label", null,
                    "Plane Angle: ",
                    (planeAngle * 180 / Math.PI).toFixed(0),
                    "\u00B0"),
                react_1.default.createElement("input", { type: "range", min: "0", max: Math.PI / 2, step: "0.01", value: planeAngle, onChange: (e) => setPlaneAngle(parseFloat(e.target.value)) })),
            react_1.default.createElement("div", { className: "curve-info" },
                react_1.default.createElement("h3", null, curveType),
                react_1.default.createElement("p", null, equation)),
            react_1.default.createElement("div", { className: "explanation", style: {
                    marginTop: '40px',
                    padding: '20px',
                    background: '#1e293b',
                    borderRadius: '8px'
                } },
                react_1.default.createElement("h3", { style: { marginBottom: '15px', color: '#f8fafc' } }, "What am I looking at?"),
                react_1.default.createElement("p", { style: { lineHeight: '1.6', color: '#e2e8f0' } }, "This visualization demonstrates how different conic sections (circle, ellipse, parabola, hyperbola) are formed by intersecting a plane with a cone. Adjust the plane's position and angle to see how the intersection changes:"),
                react_1.default.createElement("ul", { style: { lineHeight: '1.6', color: '#e2e8f0', marginTop: '10px' } },
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("strong", null, "Circle"),
                        ": Formed when the plane is perpendicular to the cone's axis"),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("strong", null, "Ellipse"),
                        ": Formed when the plane's angle is less than the cone's side angle"),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("strong", null, "Parabola"),
                        ": Formed when the plane's angle equals the cone's side angle"),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement("strong", null, "Hyperbola"),
                        ": Formed when the plane's angle is greater than the cone's side angle")),
                react_1.default.createElement("p", { style: { lineHeight: '1.6', color: '#e2e8f0', marginTop: '10px' } }, "The 3D view shows the cone and intersecting plane, while the 2D view displays just the resulting curve."))),
        react_1.default.createElement("div", { className: "canvas-container" },
            react_1.default.createElement(fiber_1.Canvas, { camera: { position: [0, 0, 8], fov: 65 } },
                react_1.default.createElement("ambientLight", { intensity: 0.5 }),
                react_1.default.createElement("pointLight", { position: [10, 10, 10] }),
                react_1.default.createElement(ConeVisualization, { planePosition: planePosition, planeAngle: planeAngle, onIntersection: (type, eqn) => {
                        setCurveType(type);
                        setEquation(eqn);
                    } }),
                react_1.default.createElement(drei_1.OrbitControls, { enableZoom: true, enablePan: true }),
                react_1.default.createElement("gridHelper", { args: [5, 20, 0x444444, 0x888888] }))),
        react_1.default.createElement("div", { className: "canvas-container", style: { marginTop: '32px' } },
            react_1.default.createElement("h3", null,
                "2D Intersection: ",
                curveType),
            react_1.default.createElement(fiber_1.Canvas, { camera: { position: [0, 0, 5], fov: 50, zoom: 2 } },
                react_1.default.createElement("ambientLight", { intensity: 0.5 }),
                react_1.default.createElement("mesh", null,
                    react_1.default.createElement("bufferGeometry", { attach: "geometry" },
                        react_1.default.createElement("bufferAttribute", { attach: "attributes-position", args: [
                                new Float32Array(curveType === 'Circle' ? generateCirclePoints(planePosition).flatMap(p => [p.x, p.y, p.z]) :
                                    curveType === 'Ellipse' ? generateEllipsePoints(planeAngle, planePosition).flatMap(p => [p.x, p.y, p.z]) :
                                        curveType === 'Parabola' ? generateParabolaPoints(planeAngle).flatMap(p => [p.x, p.y, p.z]) :
                                            generateHyperbolaPoints(planeAngle).flatMap(p => [p.x, p.y, p.z])),
                                3
                            ] })),
                    react_1.default.createElement("meshBasicMaterial", { color: "#6366f1", side: THREE.DoubleSide, transparent: true, opacity: 0.8 })),
                react_1.default.createElement("gridHelper", { args: [10, 10, 0x444444, 0x888888], rotation: [Math.PI / 2, 0, 0] })))));
};
// Helper functions to generate 2D conic sections
function generateCirclePoints(y) {
    const radius = Math.sqrt(1 - y * y);
    const points = [];
    for (let angle = 0; angle <= Math.PI * 2; angle += 0.05) {
        points.push(new THREE.Vector3(radius * Math.cos(angle), radius * Math.sin(angle), 0));
    }
    // Close the circle
    points.push(points[0].clone());
    return points;
}
function generateEllipsePoints(angle, y) {
    const a = 1;
    const b = a / Math.cos(angle);
    const points = [];
    for (let t = 0; t <= Math.PI * 2; t += 0.05) {
        points.push(new THREE.Vector3(a * Math.cos(t), b * Math.sin(t), 0));
    }
    // Close the ellipse
    points.push(points[0].clone());
    return points;
}
function generateParabolaPoints(angle) {
    const a = 0.5;
    const points = [];
    // More points for smoother curve
    for (let x = -2; x <= 2; x += 0.05) {
        points.push(new THREE.Vector3(x, a * x * x, 0));
    }
    return points;
}
function generateHyperbolaPoints(angle) {
    const a = 0.5;
    const b = a * Math.tan(angle);
    const points = [];
    // More points for smoother curves
    for (let t = -1.5; t <= 1.5; t += 0.05) {
        points.push(new THREE.Vector3(a * Math.cosh(t), b * Math.sinh(t), 0));
        points.push(new THREE.Vector3(-a * Math.cosh(t), b * Math.sinh(t), 0));
    }
    return points;
}
exports.default = ConicSectionsVisualization;
